import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ArrowLeft, Shield } from 'lucide-react';
import Header from '../Header';
import Footer from '../Footer';

export default function LegalLayout({ title, seoTitle, children, onOpenWizard }) {
  return (
    <>
      <Helmet>
        <title>{seoTitle || title} | Auth0.Expert</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="min-h-screen bg-background grid-bg">
        <Header scrolled onCTAClick={onOpenWizard} />

        <main className="max-w-4xl mx-auto px-4 pt-28 pb-20">
          {/* Breadcrumb */}
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>

          <article className="glass rounded-2xl border border-border/30 p-8 md:p-12">
            {/* Title */}
            <div className="flex items-center gap-3 mb-8 pb-6 border-b border-border/30">
              <Shield className="w-7 h-7 text-primary flex-shrink-0" />
              <h1 className="text-2xl md:text-3xl font-bold text-foreground">{title}</h1>
            </div>

            {/* Last updated */}
            <p className="text-xs text-muted-foreground mb-8">
              Dernière mise à jour : mai 2025
            </p>

            {/* Content */}
            <div className="prose-legal space-y-8 text-foreground/80 leading-relaxed">
              {children}
            </div>
          </article>

          {/* Legal links */}
          <div className="flex flex-wrap gap-4 justify-center mt-8 text-xs text-muted-foreground">
            <Link to="/mentions-legales" className="hover:text-primary transition-colors">Mentions Légales</Link>
            <span>·</span>
            <Link to="/confidentialite" className="hover:text-primary transition-colors">Politique de Confidentialité</Link>
            <span>·</span>
            <Link to="/cgv" className="hover:text-primary transition-colors">CGV</Link>
            <span>·</span>
            <Link to="/contact" className="hover:text-primary transition-colors">Nous Contacter</Link>
          </div>
        </main>

        <Footer onCTAClick={onOpenWizard} />
      </div>
    </>
  );
}
